module.exports = __webpack_public_path__ + "img/6.e9c04693.jpg";